angular.module("staff")

    .controller("StaffEditCtrl", [ 'foldersService', 'LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (foldersService, LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("STAFF_WRITE");
            $scope.allowFoldersFiles = LoginService.permissionExist("FILES_READ");

            $scope.stateParamsId = $stateParams.id;
            $scope.buttonCancel = true;

            $scope.addStaffFromEvent = function (options) {
                $scope.stateParamsId = "";
                $scope.is_external = options.isExternal;
                $scope.callbackClose = options.callbackClose;
                $scope.comeFromEvents = true;
                $scope.buttonCancel = false;
                $scope.configure();
            };


            $scope.configure = function () {
                $rootScope.title = $filter('translate')('staff.title');
                $scope.staff = {
                    is_external: $stateParams.is_external === "true"
                };

                if (angular.isDefined($scope.is_external)) $scope.staff.is_external = $scope.is_external;

                if (angular.isUndefined($stateParams.id) || $stateParams.id == "" || $scope.stateParamsId == "") {

                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('staff.title'), url: "staff.list" },
                        { title: $filter('translate')('staff.title_add') },
                    ];

                } else {
                    $rootScope.breadcrumb = [
                        { title: $filter('translate')('staff.title'), url: "staff.list" },
                        { title: $filter('translate')('staff.title_edit') },
                    ];

                    Restangular.one('Staff', $stateParams.id).get().then(function (result) {
                        $scope.staff = result;
                        $scope.staff.birthdate = new Date($scope.staff.birthdate);
                    });
                }
            }

            if ($state.is("staff.edit")) $scope.configure();

            Restangular.all('StaffPositions').getList().then(function (positions) {
                $scope.selectPositions = positions;
            });

            $scope.saveStaff = function () {
                if (angular.isDefined($scope.staff.id)) {
                    $scope.staff.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            if (angular.isUndefined($scope.comeFromEvents)) {
                                $state.go("staff.list");
                            } else {
                                $scope.callbackClose('cancel');
                            }
                            toastr.success($filter('translate')('staff.edit_success'));                            
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('Staff').post($scope.staff).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            if (angular.isUndefined($scope.comeFromEvents)) {
                                $state.go("staff.edit", { id: result.id,is_template:false});
                            } else {
                                $scope.callbackClose('cancel');
                            }
                            toastr.success($filter('translate')('staff.save_success'));                            
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }
            }

            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('staff.button_delete'),
                    message: $filter('translate')('staff.delete_message') + " " + $scope.staff.name + "?",
                    onAccept: function () {
                        $scope.staff.remove().then(function () {
                            toastr.success($filter('translate')('staff.delete_success'));
                            $state.go("staff.list");
                        });
                    }
                });
            };

            $scope.selectImage = function () {
                $("#frmPersonImage").trigger("click");
                $("#frmPersonImage").change(function () {
                    var file = (document.querySelector('#frmPersonImage') as HTMLInputElement).files[0];
                    if (file) {
                        var fileReader = new FileReader();
                        fileReader.onload = function (event) {
                            var uri = event.target.result;
                            if (angular.isUndefined($scope.staff.FK_staff_images) || $scope.staff.FK_staff_images == null) $scope.staff.FK_staff_images = {};
                            $scope.staff.FK_staff_images.image = uri;
                            $scope.staff.photo = uri;
                            $scope.staff.image_id = null; //??
                            if (!$scope.$$phase) $scope.$apply();
                        };
                        fileReader.readAsDataURL(file);
                    } else {
                        //preview.src = "";
                    }
                });
            };

            $scope.getImage = function () {
                if ($scope.staff.FK_staff_images != null && $scope.staff.FK_staff_images.image != null) {
                    return $scope.staff.FK_staff_images.image;
                } else if ($scope.staff.image_id != null) {
                    return "/api/Image/GetImageBmp?id=" + $scope.staff.image_id + "&maxW=150&maxH2=150";
                } else {
                    return "assets/img/no-user.jpeg";
                }
            };

            $scope.removeImage = function ($event) {
                $scope.staff.image_id = null; $scope.staff.photo = null;
                if ($scope.staff.FK_staff_images != null) $scope.staff.FK_staff_images.image = null;
                if (typeof ($event) !== "undefined") {
                    $event.preventDefault();
                    $event.stopPropagation();
                }
            };

            $scope.foldersFiles = function () {
                foldersService.folders("staff", $scope.staff.id, false);
            };

        }])

;

